import Competition from "model/Competition";
import League from "model/League";
import StandingsItem from "model/StandingsItem";
import {fetchApiClient} from "common/fetchApiClient";
import {API_URL} from "common/const";
import UnauthorizedError from "api/errors/UnauthorizedError";
import { AxiosError } from "axios";


const getStandings = async (competition: Competition, league: League, token: string | undefined): Promise<StandingsItem[]> => {
    const apiClient = fetchApiClient(token);

    return await apiClient.get<StandingsItem[]>(`${API_URL}/standings/${competition.code}/${league.leagueId}`)
        .then(response => {
            return response.data;
        }).catch((error: AxiosError) => {
            console.log(`Error fetching standings for Competition(${competition.code}) and League(${league.leagueId})`, competition, error);
            if (!!error.response && error.response.status === 403) {
                throw new UnauthorizedError();
            }
            throw error;
        });
}

export default getStandings;
